import deployEnv from 'environment-paypal';

const PROD_HOSTNAME = 'https://www.paypal.com';
const STAGE_HOSTNAME = 'https://www.msmaster.qa.paypal.com';
const SB_HOSTNAME = 'https://www.sandbox.paypal.com';

const getHost = () =>
  typeof window === 'undefined' ? getHostServerSide() : getHostClientSide();

const getHostClientSide = () => {
  const { hostname, protocol } = window.location;
  return hostname.includes('localhost')
    ? STAGE_HOSTNAME
    : `${protocol}//${hostname}`;
};

const getHostServerSide = () => {
  if (deployEnv.isDev() || deployEnv.isStage()) {
    return STAGE_HOSTNAME;
  } else if (deployEnv.isSandbox()) {
    return SB_HOSTNAME;
  }
  return PROD_HOSTNAME;
};

export { getHost };
